/**
 * 📱 Página Pública de Conexão WhatsApp
 * 
 * O QUE FAZ:
 * - Permite que clínicas conectem WhatsApp via link único
 * - Não requer login no sistema
 * - Exibe QR Code e código de pareamento
 * 
 * ONDE É USADA:
 * - Rota pública: /conectar-whatsapp/:token
 * 
 * COMO FUNCIONA:
 * 1. Admin gera link no painel
 * 2. Cliente recebe link e abre no navegador
 * 3. Sistema valida token automaticamente
 * 4. Cliente digita número do WhatsApp
 * 5. QR Code aparece na tela
 * 6. Cliente escaneia e conecta
 */

import { useParams } from 'react-router-dom';
import { PublicWhatsAppConnect } from '@/components/public/PublicWhatsAppConnect';

export default function PublicWhatsAppConnectPage() {
  // Extrair token da URL
  const { token } = useParams<{ token: string }>();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <PublicWhatsAppConnect token={token || ''} />
    </div>
  );
}
